import useInitializeNewspaperAdvancedForm from './useInitializeNewspaperAdvancedForm'

export default useInitializeNewspaperAdvancedForm
